import {array, bool, func, number, shape, string} from 'prop-types';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import Input from '../../shared/Input';
import {Box, Stack} from '../../shared/layouts';
import Select from '../../shared/Select';
import FormStack from '../../shared/layouts/FormStack';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";
import {useTheme} from "@emotion/react";
import {useMediaQuery} from "@dnhb/node_package";

const GeneralSection = ({
  originalAmount,
  mortgagenumber,
  registrationAmount,
  currentAmount,
  ltv,
  grossMonthlyPayment,
  netMonthlyPayment,
  fine,
  provider,
  label,
  providers,
  errors,
  canEditMortgage,
  setMortgage,
  mortgageIndex,
  repayment,
  interestExpense,
}) => {
  const { t } = useTranslation();
  const mortgageLabels = providers.find(
    (item) => item.value === provider
  )?.labels;
  const readOnly = !canEditMortgage;
  const FormFiller = (props) => !readOnly && <Box {...props} />;
  const { HouseIcon } = useIconLibrary();

  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t("Algemene gegevens")}
          icon={<HouseIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          {/* Row */}
          <Select
            autoFocus
            name="provider"
            label={isMinDesktop ? t("Hypotheekverstrekker") : t("Geldverstrekker")}
            onChange={setMortgage}
            options={
              providers.map((provider) => ({
                label: provider.label,
                value: provider.value,
              })) || []
            }
            value={provider}
            errors={errors[`${mortgageIndex}.provider`]}
            isSearchable
            readOnly={readOnly}
          />
          <Select
            autoFocus
            name="label"
            label={t("Product")}
            clearKey={provider}
            onChange={setMortgage}
            options={mortgageLabels || []}
            value={label}
            errors={errors[`${mortgageIndex}.label`]}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            name="mortgagenumber"
            value={mortgagenumber}
            onChange={setMortgage}
            label={t("Hypotheeknummer")}
            placeholder={t("Vul je hypotheeknummer in")}
            errors={errors[`${mortgageIndex}.mortgagenumber`]}
            readOnly={readOnly}
          />
          <FormFiller />
          {/* Row */}
          <Input
            isCurrency
            name="registrationAmount"
            value={registrationAmount}
            label={t("Hypothecaire inschrijving")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.registrationAmount`]}
            readOnly={readOnly}
          />
          <Input
            isCurrency
            name="originalAmount"
            value={originalAmount}
            label={t("Oorspronkelijke schuld")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.originalAmount`]}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            isCurrency
            name="currentAmount"
            value={currentAmount}
            label={t("Resterende schuld")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.currentAmount`]}
            readOnly={readOnly}
          />
          <Input
            isPercentage
            name="ltv"
            value={ltv}
            label={t("Actuele tariefklasse")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.ltv`]}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            isCurrency
            name="interestExpense"
            value={interestExpense}
            label={t("Rentelast")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.interestExpense`]}
            readOnly={readOnly}
          />
          <Input
            isCurrency
            name="repayment"
            value={repayment}
            label={t("Aflossing")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.repayment`]}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            isCurrency
            name="grossMonthlyPayment"
            value={grossMonthlyPayment}
            label={t("Bruto maandlast")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.grossMonthlyPayment`]}
            readOnly={readOnly}
          />
          <Input
            isCurrency
            name="netMonthlyPayment"
            value={netMonthlyPayment}
            label={t("Netto maandlast")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.netMonthlyPayment`]}
            readOnly={readOnly}
          />
          <Input
            isCurrency
            name="fine"
            value={fine}
            label={t("Boete bij oversluiten")}
            onChange={setMortgage}
            errors={errors[`${mortgageIndex}.fine`]}
            readOnly={readOnly}
          />
        </FormStack>
      </Stack>
    </Card>
  );
};

GeneralSection.propTypes = {
  originalAmount: number,
  mortgagenumber: string,
  provider: number,
  label: number,

  providers: array,
  errors: shape({}),
  canEditMortgage: bool,
  setMortgage: func.isRequired,
  mortgageIndex: number.isRequired,
};

GeneralSection.defaultProps = {
  originalAmount: null,
  mortgagenumber: '',
  provider: null,
  label: null,

  providers: [],
  errors: {},
  canEditMortgage: false,
};

export default GeneralSection;
